import { createRouter, createWebHistory } from 'vue-router'
import DataDesc from '@/views/DataDesc.vue'
import UseRegister from "@/views/UseRegister.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import Download from "@/views/Download.vue";
import MemberPay from "@/views/MemberPay.vue";
import FamilyConfig from "@/views/FamilyConfig.vue";
import DoumiConfig from "@/views/DoumiConfig.vue";
import DebugView from "@/views/DebugView.vue";
import StartAd from "@/views/StartAd.vue";
import RobotPay from "@/views/pay/RobotPay.vue";
import ScriptPay from "@/views/pay/ScriptPay.vue";
import DokoDownload from "@/views/DokoDownload.vue";

const routes = [
    {
        path: '/',
        name: Download.name,
        component: Download,
    },
    {
        path: '/register',
        name: UseRegister.name,
        component: UseRegister,
    },
    {
        path: '/debug',
        name: DebugView.name,
        component: DebugView,
    },
    {
        path: '/data-desc',
        name: DataDesc.name,
        component: DataDesc,
    },
    {
        path: '/privacy-policy',
        name: PrivacyPolicy.name,
        component: PrivacyPolicy,
    },
    // {
    //     path: '/download',
    //     name: Download.name,
    //     component: Download,
    // },
    {
        path: '/pay',
        name: MemberPay.name,
        component: MemberPay,
    },
    {
        path: '/robot-pay',
        name: RobotPay.name,
        component: RobotPay,
    },
    {
        path: '/script-pay',
        name: ScriptPay.name,
        component: ScriptPay,
    },
    {
        path: '/family-config',
        name: FamilyConfig.name,
        component: FamilyConfig,
    },
    {
        path: '/doumi-config',
        name: DoumiConfig.name,
        component: DoumiConfig,
    },
    {
        path: '/start-ad',
        name: StartAd.name,
        component: StartAd,
    },
    {
        path: '/doko-download',
        name: DokoDownload.name,
        component: DokoDownload,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    next();
});

export default router
